import React, {useEffect, useState} from 'react';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Breadcrumb from './components/Breadcrumb';
import Search from './components/Search';
import RepoStructure from './components/RepoStructure';
import AppTypeForm from './components/AppTypeForm';
import SearchResults from "./components/SearchResults";

function App() {
    const octoAppType = "Octo+ App";
    const infraAppType = "Infra App";

    const [searchRepoStructure, setSearchRepoStructure] = useState([]);
    const [repoStructure, setRepoStructure] = useState([]);
    const [currentPath, setCurrentPath] = useState('');
    const [appType, setAppType] = useState('');
    const [versionFields, setVersionFields] = useState({
        octoVersion: '',
        infraVersion: '',
        infraAppVersion: ''
    });
    const [otherEnvsVersion, setOtherEnvsVersion] = useState([]);
    const [currentEnvInfos, setCurrentEnvInfos] = useState({});
    const [envVersionsLoading, setEnvVersionsLoading] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);
    const [actionInProgress, setActionInProgress] = useState(false);
    const [pipelineState, setPipelineState] = useState("idle");
    const [searchRepoStructureLoading, setSearchRepoStructureLoading] = useState(true);

    useEffect(() => {
        async function fetchRepoStructure(path = '') {
            setSearchRepoStructureLoading(true);
            try {
                const {data} = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/repo-structure?path=${path}`);
                const argocdappFile = data.values.filter(x => x.path.includes('argocd-app'))[0];
                if (argocdappFile) {
                    setRepoStructure([]);
                    const {data: fileContent} = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/file-content?path=${argocdappFile.path}`);
                    if (fileContent.includes('helm/octo')) {
                        setAppType(octoAppType);
                        setEnvVersionsLoading(true);
                        setCurrentEnvInfos({});
                        setOtherEnvsVersion([]);
                        const {data: currentEnvInfos} = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/environment/infos?path=${path}`);
                        console.log(currentEnvInfos);
                        setCurrentEnvInfos(currentEnvInfos);

                        const {data: otherEnvsVersions} = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/search/environments/version?path=${path}`);
                        setOtherEnvsVersion(otherEnvsVersions);

                        setEnvVersionsLoading(false);
                    } else {
                        setAppType(infraAppType);
                    }
                } else {
                    setRepoStructure(data.values);
                    setAppType('');
                }
            } catch (error) {
                console.error(error);
            }
            setSearchRepoStructureLoading(false);
            setEnvVersionsLoading(false);
        }

        fetchRepoStructure(currentPath);
    }, [currentPath]);

    const navigateToFolder = (path) => {
        setSearchRepoStructure([]);
        setCurrentPath(path);
        setPipelineState("idle");
    };

    const goBack = () => {
        const pathParts = currentPath.split('/');
        pathParts.pop();
        setCurrentPath(pathParts.join('/'));
        setPipelineState("idle");
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSearch = async () => {
        try {
            setSearchLoading(true);
            setSearchRepoStructure([]);
            const {data} = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/search?searchTerm=${searchTerm}`);
            setSearchLoading(false);
            setSearchRepoStructure(data.values);
        } catch (error) {
            console.error(error);
        }
    };

    const closeSearch = async () => {
        try {
            setSearchRepoStructure([]);
        } catch (error) {
            console.error(error);
        }
    };

    const triggerUpdateAppPipeline = async () => {
        if (!currentPath || (!versionFields.octoVersion && !versionFields.infraVersion && !versionFields.infraAppVersion)) {
            alert('Please navigate to a directory and provide required versions before triggering the pipeline.');
            return;
        }
        const confirmMessage = `Are you sure you want to trigger the pipeline?
          Path: ${currentPath}
          ${appType === octoAppType ? `Octo Version: ${versionFields.octoVersion}\nInfra Version: ${versionFields.infraVersion}` : `Infra App Version: ${versionFields.infraAppVersion}`}`;

        if (!window.confirm(confirmMessage)) {
            return;
        }

        setPipelineState("loading");

        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/mute/app`, {service: currentEnvInfos.service, namespace: currentEnvInfos.namespace, cluster: currentEnvInfos.cluster});
            const apiEndpoint = appType === octoAppType ? "octo-app-update-pipeline" : "infra-app-update-pipeline";
            const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/${apiEndpoint}`, {
                selectedDirectory: currentPath,
                ...versionFields,
            });
            setPipelineState("success");
            setTimeout(() => window.open(data.url, "_blank"), 1000);
        } catch (error) {
            console.error(error);
            alert("Error triggering pipeline.");
            setPipelineState("failed");
        }
    };

    const triggerOctoAppStopPipeline = async () => {
        try {
            setActionInProgress(true);
            const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/octo-app-stop-pipeline`, {selectedDirectory: currentPath});
            setActionInProgress(false);
            window.open(data.url, "_blank");
        } catch (error) {
            console.error(error);
            alert("Error triggering pipeline.");
        }
    };

    const triggerOctoAppStartPipeline = async () => {
        try {
            setActionInProgress(true);
            const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/octo-app-start-pipeline`, {selectedDirectory: currentPath});
            setActionInProgress(false);
            window.open(data.url, "_blank");
        } catch (error) {
            console.error(error);
            alert("Error triggering pipeline.");
        }
    };

    const triggerOctoAppRestartPipeline = async () => {
        try {
            setActionInProgress(true);
            const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/octo-app-restart-pipeline`, {selectedDirectory: currentPath});
            setActionInProgress(false);
            window.open(data.url, "_blank");
        } catch (error) {
            console.error(error);
            alert("Error triggering pipeline.");
        }
    };

    const triggerArgoAppUpdatePipeline = async () => {
        try {
            setActionInProgress(true);
            const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/argo-app-update-pipeline`, {selectedDirectory: currentPath});
            setActionInProgress(false);
            window.open(data.url, "_blank");
        } catch (error) {
            console.error(error);
            alert("Error triggering pipeline.");
        }
    };

    const muteAppAlerts = async () => {
        try {
            setActionInProgress(true);
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/mute/app`, {service: currentEnvInfos.service, namespace: currentEnvInfos.namespace, cluster: currentEnvInfos.cluster});
            setActionInProgress(false);
        } catch (error) {
            console.error(error);
            setActionInProgress(false);
            alert("Error muting alerts.");
        }
    };


    const muteClusterAlerts = async (clusterName) => {
        try {
            setActionInProgress(true);
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/mute/cluster`, {clusterName: clusterName});
            setActionInProgress(false);
            alert("Alerts muted successfully for the cluster " + clusterName);
        } catch (error) {
            console.error(error);
            setActionInProgress(false);
            alert("Error muting alerts.");
        }
    };

    const handleVersionChange = (field, value) => {
        setVersionFields(prev => ({...prev, [field]: value}));
    };

    const subtitle = () => {
        const nbFolders = currentPath ? currentPath.split("/").length : 0;
        const forWhat = currentPath.split('/').pop();
        const isClusterPage = nbFolders === 2;
        return (
            <div className="d-inline-flex gap-2 align-items-baseline">
                <h2 className="h5">
                    {(nbFolders === 0 ? "Choose a Typology" : (nbFolders === 1 ? "Choose a Cluster for type " : "Choose an APP for cluster "))}
                </h2>
                <h2 className="text-primary h5 fw-bold">{forWhat}</h2>
    </div>
    )
        ;
    };
    const logo = () => {
        return (
            <i className="bi bi-folder-fill me-2"></i>
        );
    };

    return (
        <>
            <Header/>
            <div className="h-100 mb-5 pe-5 ps-5 pt-3 overflow-auto">
                <div className="d-inline-flex mb-3 justify-content-between w-100">
                    <Breadcrumb currentPath={currentPath} setCurrentPath={setCurrentPath}/>
                    <Search
                        searchTerm={searchTerm}
                        handleSearchChange={handleSearchChange}
                        handleSearch={handleSearch}
                    />
                </div>
                {(searchRepoStructure.length > 0 || searchLoading) && (
                    <SearchResults
                        closeSearch={closeSearch}
                        searchRepoStructure={searchRepoStructure}
                        searchLoading={searchLoading}
                        navigateToFolder={navigateToFolder}
                    />
                )}
                {!appType && (
                    <RepoStructure
                        searchRepoStructureLoading={searchRepoStructureLoading}
                        repoStructure={repoStructure}
                        currentPath={currentPath}
                        navigateToFolder={navigateToFolder}
                        goBack={goBack}
                        subtitle={subtitle}
                        logo={logo}
                        muteClusterAlerts={muteClusterAlerts}
                    />)}
                {appType && (
                    <AppTypeForm
                        appType={appType}
                        currentPath={currentPath}
                        versionFields={versionFields}
                        handleVersionChange={handleVersionChange}
                        triggerUpdateAppPipeline={triggerUpdateAppPipeline}
                        triggerOctoAppStopPipeline={triggerOctoAppStopPipeline}
                        triggerOctoAppStartPipeline={triggerOctoAppStartPipeline}
                        triggerOctoAppRestartPipeline={triggerOctoAppRestartPipeline}
                        triggerArgoAppUpdatePipeline={triggerArgoAppUpdatePipeline}
                        muteAppAlerts={muteAppAlerts}
                        actionInProgress={actionInProgress}
                        pipelineState={pipelineState}
                        goBack={goBack}
                        otherEnvsVersion={otherEnvsVersion}
                        envVersionsLoading={envVersionsLoading}
                        currentEnvInfos={currentEnvInfos}
                    />)}

            </div>
            <Footer/>
        </>
    );
}

export default App;
